import React from 'react';
import {
  Card,
  CardTitle,
  Button,
  CardBody,
  Typography,
  CardActions,
} from '@one-thd/sui-atomic-components';
import { ADDRESSES_PATH } from '../../constants/links';

export const EmptyCard = () => {
  return (
    <Card grow PaperProps={{ className: 'sui-flex sui-h-full' }} data-component="ShippingAddressCardEmptyCard">
      <CardTitle
        header={(
          <Typography height="tight" variant="h3" weight="bold">
            Addresses
          </Typography>
        )}
      />
      <CardBody className="sui-flex sui-overflow-hidden sui-flex-row sui-justify-between sui-h-full">
        <Typography variant="body-lg">
          You don&apos;t have a default address. Add, edit or delete your saved addresses for quick and
          easy checkout.
        </Typography>
      </CardBody>
      <CardActions>
        <Button fullWidth variant="secondary" href={ADDRESSES_PATH}>
          Set Default Address
        </Button>
      </CardActions>
    </Card>
  );
};

EmptyCard.displayName = 'EmptyCard';